import React from "react";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import {
  Button,
  CircularProgress,
  Snackbar,
  Slide,
} from "@material-ui/core";
import Http from "../../../Http";
import { withRouter } from "react-router-dom";

class GuiasSelectV2 extends TableComponent {
  componentDidMount() {
    const { id_cliente, start_date, end_date, id, guias } = this.props;
    if (guias && guias.length > 0) {
      this.setState({ guias });
    }
    this.tableConfig(
      {
        dataUrl: `facturacion/search/guiasbycliente?cliente_id=${id_cliente}&start_date=${start_date}&end_date=${end_date}&id=${id}`,
        deleteUrl: false,
        deleteField: false,
        modUrl: false,
      },
      TableOp.Table("Guias", [
        {
          label: "Facturar",
          id: "recibida",
          type: "checkbox",
          callback: this.onValueChange,
        },
        { label: "Guia", id: "g_folio" },
        { label: "Total de la guia", id: "g_costo_total" },
        { label: "Cliente", id: "cliente_rsocial" },
        { label: "Origen", id: "g_origen" },
        { label: "Destino", id: "g_destino" },
      ])
    );
    this.table();
    this.inputFileRef = React.createRef();
  }

  uploadFile = () => {
    this.inputFileRef.current.click();
  };

  async table(page = this.page, limit = this.rpp, q = this.q, orderBy = this.orderBy, order = this.order) {
    this.page = page;
    this.rpp = limit;
    this.setState({ loading: true });
    try {
      if (!q) {
        const urlParams = new URLSearchParams(window.location.search);
        q = urlParams.get("qt");
        let pages = urlParams.get("page");
        if (pages) {
          page = parseInt(pages);
          this.page = page;
        }
      }
      if (!this.config.dataUrl) {
        return false;
      }
      const nexo = this.config.dataUrl && this.config.dataUrl.includes("?") ? "&" : "?";
      let Res = await Http.get(
        `${this.config.dataUrl}${nexo}p=${page}&l=${limit}${
          q ? `&q=${q}` : ""
        }${orderBy ? `&orderBy=${orderBy}&order=${order}` : ""}`
      );
      Res.data.rows = Res.data.rows.map((row, i) => {
        if (this.state.guias && this.state.guias.some((guia) => guia === row.id)) {
          row["recibida"] = true;
        }
        return row;
      });

      this.setState({
        tableData: {
          ...this.state.tableData,
          rows: Res.data.rows,
          total: Res.data.total,
          q,
          page: this.page,
        },
        loading: false,
      });
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id_cliente !== this.props.id_cliente) {
      const { id_cliente, start_date, end_date } = this.props;
      this.config.dataUrl = `facturacion-search/guiasbycliente?cliente_id=${id_cliente}&start_date=${start_date}&end_date=${end_date}`;
      this.table();
    }
    if (prevProps.loading !== this.props.loading) {
      this.setState({ loading: this.props.loading });
    }
  }

  onValueChange = (event, index, field) => {
    let { tableData, guias = [] } = this.state;
    let value = event.target.value;
    let rows = [];
    rows = tableData.rows.slice();
    rows[index][field] = value;
    if (value) {
      guias.push(rows[index].id);
    } else {
      guias = guias.filter((guia) => guia !== rows[index].id);
    }
    this.setState({ tableData: { ...tableData, rows }, guias });
    this.props.onChangeGuias(guias);
  };

  onFileUpload = async (e) => {
    let form = new FormData();
    form.append("file", e.target.files[0]);
    form.append("id_factura", this.props.id);
    form.append("id_cliente", this.props.id_cliente);
    try {
      let res = await Http.post(`facturacion/save-guias-file`, form);
      if (!res.error) {
        this.setState({ sbOpen: true, sbMsg: res.data || "Guardado Correctamente" });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        this.setState({ sbOpen: true, sbMsg: res.errMsg });
      }
      this.inputFileRef.current.value = null;
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { loading, sbOpen, sbMsg, guias = [] } = this.state;

    return (
      <div style={{ padding: 15 }}>
        <div style={{ width: "100%", display: "flex", justifyContent: "space-between", marginBottom: 15 }}>
          <strong>Cantidad de guías seleccionadas: {guias.length}</strong>
          {this.props.id && !this.props.timbrado && (
            <>
              <Button variant="outlined" color="primary" onClick={this.uploadFile}>Subir guías CSV</Button>
              <input
                type="file"
                hidden={true}
                ref={this.inputFileRef}
                accept=".csv"
                onChange={this.onFileUpload}
              />
            </>
          )}
        </div>
        <this.TableRender />
        <Snackbar
          open={sbOpen}
          onClose={() => { this.setState({ sbOpen: false }); }}
          TransitionComponent={Slide}
          ContentProps={{ "aria-describedby": "message-id" }}
          message={<span id="message-id">{sbMsg}</span>}
        />
      </div>
    );
  }
}

export default withRouter(GuiasSelectV2);
